/**
* スクラッチのコンストラクタ
* @constructor
* @param {selector} el - セレクタ
*/
module.exports = Scratch = function(el){
  this.element = $(el);
  this.checkDevice();
  this.init();
};

/**
* initialize
*/
Scratch.prototype.init = function(){
  var self = this;
  this.daily = $('.js-scratch-daily');
  this.panel = $('.js-scratch-panel');
  this.scratch = $('#jsScratchAnimation');
  this.win = $('.js-scratch-confetti');
  this.recipes = [
    {
      'intro': 'こんにちは！かんたん2ステップであっという間に出来上がる・・・',
      'name': 'ごちカツくんだポ！！',
      'desc': '揚げないタイプのトンカツだからさっぱりヘルシーだポ。',
      'menu': '2ステップでカンタン！ 今日はごちカツ作ろう！'
    },
    {
      'intro': 'ハロー！ステキな厚切りステーキの…',
      'name': 'ごちテキくんだポォ〜！！',
      'desc': '弱火でじっくり焼くと、お肉が柔らかジューシーに仕上がるポォ〜！！',
      'menu': 'ステキな厚切りステーキ 今日はごちテキ作ろう！'
    },
    {
      'intro': '今日もありがとッス！ちょっとピリ辛でご飯がモリモリ進んじゃう…',
      'name': 'ごちしょうがくんッス！！',
      'desc': '味の決め手は豆板醤ッス！今日もモリモリ食べるッス！ポ！！',
      'menu': 'ちょっとピリ辛 今日はごちしょうが作ろう！'
    },
    {
      'intro': 'ご機嫌いかが？お肉と一緒に野菜もたっぷり摂れちゃう…',
      'name': 'ごちしゃぶくんですポ！！',
      'desc': 'すりごまソースのビタミンEでお肌もキレイになっちゃうポ！',
      'menu': '野菜もモリモリ食べられる 今日はごちしゃぶ作ろう！'
    },
    {
      'intro': 'こんにちは！超かんたんジューシーでスペシャルな一品…',
      'name': 'ごちローストくんだポ！！',
      'desc': '塩コショウしてオーブンに入れるだけ!ごちポの代表的料理だポ！！',
      'menu': '超カンタンやわらかな 今日はごちロースト作ろう！'
    },
    {
      'intro': '毎度どうも！トロッとやわらか味わい深い…',
      'name': 'ごち煮くんと申しますポ！！',
      'desc': 'かたまり肉から切り出して作るとよりリーズナブルだポ！',
      'menu': 'とろけるうまさの 今日はごち煮作ろう！'
    }
  ];
  this.confettis = [
    '/images/confetti/01.png',
    '/images/confetti/02.png',
    '/images/confetti/03.png',
    '/images/confetti/04.png'
  ];
  this.event();
};

/**
* イベント
*/
Scratch.prototype.event = function(){
  var self = this;

  // 日めくり
  this.initDaily();

  // canvas ok
  var hasCanvas = !!window.HTMLCanvasElement;
  if(hasCanvas){
    this.initCanvas();
  }else{
    this.panel.find('li').on('click', function(){
      self.changePanelClass($(this));
    });
  }
  

  // 表示
  this.element.addClass('is-ready');
  this.panel.eq(0).addClass('is-visible');

  // スクラッチ
  if(this.scratch.length){
    var PRELOAD_TIME = 2000;
    var FRAME_RATE = 25;
    var FRAME_TIME = 100;
    var imgPath = this.scratch.css('background-image');
    imgPath = imgPath.replace('url(','').replace(')','').replace(/\"/gi, "");
    this.preload(imgPath, PRELOAD_TIME).done(function(){
      self.element.addClass('is-start');
      self.animation(FRAME_RATE, FRAME_TIME);
    });
  }

  // result
  if(this.win.length){
    this.result(this.win);
  }
};

/**
* 日替わりを生成
*/
Scratch.prototype.initDaily = function(){
  var self = this;

  // 21日にカツになるようプラスする
  var PLUS_DATE = 3;

  // 開始日
  var START_DATE = '0421';

  // 日付に応じてDOM変更
  var today = this.getDate();
  var recipeNum = (today[1] + PLUS_DATE) % this.recipes.length;

  var calendarDate = this.zeroPadding(today);
  calendarDate = (calendarDate >= START_DATE) ? calendarDate : START_DATE ;

  var dom = '';
  dom += '<ul class="scratch-canvas js-scratch-canvas">';
  dom += '<li><img src="/images/calendar/cal_'+calendarDate+'.png" alt="'+today[0]+'月'+today[1]+'月"></li>';
  dom += '<li><img src="/images/intro/intro_01.png" alt="いろんなごちポを紹介するポ！"></li>';
  dom += '<li><img src="/images/intro/intro_02_'+(recipeNum+1)+'.png" alt="'+this.recipes[recipeNum].intro+'"></li>';
  dom += '<li><img src="/images/intro/intro_03_'+(recipeNum+1)+'.png" alt="'+this.recipes[recipeNum].name+'"></li>';
  dom += '<li><img src="/images/intro/intro_04_'+(recipeNum+1)+'.png" alt="'+this.recipes[recipeNum].desc+'"></li>';
  dom += '<li><img src="/images/intro/intro_05_'+(recipeNum+1)+'.png" alt="'+this.recipes[recipeNum].menu+'"></li>';
  dom += '<li><img src="/images/intro/intro_07.png" alt=""></li>';
  dom += '</ul>';

  // DOM生成
  this.daily.append(dom);
};

/**
* 日付取得
* @return {array} - [month, date]
*/
Scratch.prototype.getDate = function(){
  var self = this;
  this.date = new Date();
  var month = this.date.getMonth() +1;
  var date = this.date.getDate();
  return [month, date];
};

/**
* 日付をゼロパディングする
* @param {array}
* @return {string}
*/
Scratch.prototype.zeroPadding = function(array){
  var num = [];
  for(var i = 0; i < array.length; i++){
    num.push(('0' + array[i]).substr(-2));
  }
  return num[0]+num[1];
};

/**
* 日めくり
*/
Scratch.prototype.initCanvas = function(){
  var self = this;

  this.canvas = $('.js-scratch-canvas');
  this.width = this.canvas.width();
  this.height = this.canvas.outerHeight();

  var $desc = $('.js-scratch-desc');

  this.canvas.jFlip(this.width,this.height,{
    background: '#f8f4eb',
    gradientColors: ['#e5e0d8', '#cecbc4', '#e6e3da'],
    cornersTop: false,
    scale: 'fit',
    curlSize: 0.1,
    speed: 3000
  }).bind('flip.jflip',function(event,index,total){
    if(index === 1){
      $desc.addClass('is-visible');
    }
    if(index+1 === total){
      var _this = $(this);
      $desc.removeClass('is-visible');
      setTimeout(function(){
        self.changePanelClass(_this);
      }, 400);
    }
  });

  // bugfix for android
  if(window.navigator && window.navigator.userAgent.indexOf('534.30') > 0){
    $('canvas').parents('*').css('overflow', 'visible');
  }
};

/**
* scratch-panelのclass付け替え
* @param {selector} el - セレクタ
*/
Scratch.prototype.changePanelClass = function(el){
  var self = this;
  this.panel.removeClass('is-visible');
  el.closest(this.panel).next().addClass('is-visible');
};

/**
* スクラッチアニメのスプライト画像プリロード
* @param {string} path - スプライト画像パス
* @param {number} time - ローディング早すぎ用の調整時間
* @return {object} プロミスオブジェクト
*/
Scratch.prototype.preload = function(path, time){
  var self = this;

  var defer = $.Deferred();

  var sprite = new Image();
  sprite.src = path;
  sprite.onload = function(){
    setTimeout(function(){
      defer.resolve();
    }, time);
  }
  sprite.onerror = function(){
    defer.reject();
  }

  return defer.promise();
};

/**
* スクラッチアニメーション
* @param {string} rate - コマ数
* @param {number} speed - スピード
*/
Scratch.prototype.animation = function(rate, speed){
  var self = this;

  var i = 0;
  var timer = setInterval(function(){
    self.scratch.removeClass(function(index, className){
      return (className.match(/\bani-\S+/g) || []).join(' ');
    }).addClass('ani-'+i);
    if(i >= rate-1){
      clearInterval(timer);
      setTimeout(function(){
        window.location.href = 'result';
      },1500);
    } else {
      i++;
    }
  }, speed);
};

/**
* 紙吹雪
* @param {selector} el - jqueryセレクタ
*/
Scratch.prototype.result = function(el){
  var self = this;

  var opt = (this.device === 'pc') ? {
    flakeCount : 300,
    flakeIndex : 50,
    maxSpeed : 3,
    minSpeed : 0.6,
    maxSize : 14,
    minSize : 5,
    image : self.confettis
  } : {
    flakeCount : 60,
    flakeIndex : 50,
    maxSpeed : 3,
    minSpeed : 0.6,
    maxSize : 8,
    minSize : 4,
    image : self.confettis
  } ;

  el.closest('.pj-contents').snowfall(opt);
};

/**
* デバイスチェック
*/
Scratch.prototype.checkDevice = function(){
  this.device = $('.sc-main').css('position') == 'relative' ? 'sp' : 'pc';
}



//////////////////
// WEBPACK FOOTER
// ./js/_modules/scratch.js
// module id = 3
// module chunks = 0